<div class="container" [ngClass]="{ full: innerWidth < 1000 }">
  <div id="report-content-container" class="content-container">
    @if (activeSectionIndex === -1) {
      <app-report-main-info (signature)="signature.emit($event)" />
    } @else if (activeSectionIndex === sections.length) {
      @if (IS_TRS_PROJECT) {
        <div class="question-container" [innerHTML]="'report.actions.uploadPDF' | translate"></div>
      } @else if (IS_PRODUCT_SAFETY_PROJECT) {
        <div class="question-container">{{ "report.actions.uploadPDF" | translate }}</div>
      }
      @if (!hasDocument) {
        <sag-ui-filedrop
          class="file-drop"
          accept="application/pdf"
          [disabled]="!isAbleToEditAsSpecialist || isReleased"
          [multiple]="false"
          (change)="uploadDocument($event)">
          <span class="icon-upload"></span>
          <p>
            <b>Click to upload</b>
            or drag and drop
          </p>
          <p class="accepted-files-text">Accepted file types: PDF</p>
        </sag-ui-filedrop>
      } @else {
        <div class="uploaded-document">
          @let file = getFile();
          <div class="uploaded-document-item">
            <span class="document-close icon-close" (click)="clearDocument()"></span>
            <span class="document-icon icon-document-pdf" (click)="downloadDocument()"></span>
            <div class="document-name">{{ file.name }}</div>
            <div class="document-metadata">
              <span>{{ getFileLastModifiedDate(file) | date: "dd-MM-yyyy" }}</span>
              <span>{{ getFileSize(file) }} MB</span>
            </div>
          </div>
        </div>
      }
    } @else {
      <div class="section-header">
        <div class="section-title">{{ getItemTitle(section) }}</div>
        <div class="section-guidance">
          <sag-ui-button icon="circle-help" [square]="true" (click)="showSectionGuidance(section)" />
        </div>
      </div>
      @for (area of areas; track area) {
        @if (isAreaDependencySatisfied(section, area)) {
          <div id="form-container-{{ $index }}" class="main-dynamic-container">
            <div class="question-container">
              <div class="question" [innerHTML]="areaDescription(area)"></div>
              @if (area?.guidanceText && !isReleased) {
                @if (IS_TRS_PROJECT) {
                  <sag-ui-button id="guidance-button-{{ $index }}" icon="circle-help" [square]="true" (click)="showGuidance(section, area.guidanceText)" />
                } @else if (IS_PRODUCT_SAFETY_PROJECT) {
                  <sag-ui-button
                    id="guidance-button-{{ $index }}"
                    icon="circle-help"
                    [square]="true"
                    (click)="showGuidance(section, area.guidanceText, area.guidanceTextDe)" />
                }
              }
            </div>
            <div class="flex-row row-container" [ngClass]="{ last: $last }">
              <div class="single-row-container">
                @let rows = area.rows[0];
                @switch (area.questionType) {
                  @case ("text") {
                    @let textField = rows[0];
                    <app-editor
                      [(ngModel)]="report.reportValues[textField.valueId].value"
                      [disabled]="!isAbleToEditAsSpecialist || isReleased || isApproved(area)"
                      (valueChange)="editorChanged(section)" />
                  }
                  @case ("yesNo") {
                    @let radioField = rows[0];
                    <div class="yes-no-container">
                      <sag-ui-radio-group>
                        <sag-ui-radio
                          name="radio-group--{{ radioField.valueId }}"
                          value="true"
                          [(ngModel)]="report.reportValues[radioField.valueId].value"
                          [disabled]="!isAbleToEditAsSpecialist || isReleased || isApproved(area)"
                          (change)="radioChanged(section, radioField.valueId, $event)">
                          {{ "generic.truthy.true" | translate }}
                        </sag-ui-radio>
                        <sag-ui-radio
                          name="radio-group--{{ radioField.valueId }}"
                          value="false"
                          [(ngModel)]="report.reportValues[radioField.valueId].value"
                          [disabled]="!isAbleToEditAsSpecialist || isReleased || isApproved(area)"
                          (change)="radioChanged(section, radioField.valueId, $event)">
                          {{ "generic.truthy.false" | translate }}
                        </sag-ui-radio>
                      </sag-ui-radio-group>

                      @let answer = report.reportValues[radioField.valueId].value;
                      @if (showTextArea(area, answer)) {
                        @let textField = rows[1];
                        @let explanation = answer === "true" ? "report.item.explanation.yes" : "report.item.explanation.no";
                        <app-editor
                          [label]="explanation | translate"
                          [required]="area.isExplanationMandatory"
                          [disabled]="!isAbleToEditAsSpecialist || isReleased || isApproved(area)"
                          [(ngModel)]="report.reportValues[textField.valueId].value"
                          (valueChange)="editorChanged(section)" />
                      }
                    </div>
                  }

                  @case ("value") {
                    @let valueField = rows[0];
                    <div class="value-container">
                      <div class="flex-row">
                        <sag-ui-input
                          type="number"
                          label="Please enter a numeric value to answer the question:"
                          [(ngModel)]="report.reportValues[valueField.valueId].value"
                          [disabled]="!isAbleToEditAsSpecialist || isReleased || isApproved(area)"
                          (change)="onAnswerChanged(section)">
                        </sag-ui-input>
                      </div>
                    </div>
                  }
                }
              </div>
              <div class="label-checkbox approved-checkbox">
                <sag-ui-checkbox
                  [checked]="isApproved(area)"
                  [disabled]="isApproveDisabled(area, report)"
                  (change)="onApproveChanged(area, section, report, $event)">
                  {{ "report.item.approved" | translate }}
                </sag-ui-checkbox>
              </div>
            </div>
          </div>
        }
      }
    }
  </div>
</div>
